import styled from 'styled-components';

export const NotiIconImage = styled.img`
  margin: 0 0 0.2rem;
  width: auto;
  height: 1.75rem;
  animation: up-down 0.5s infinite ease-in-out alternate;

  @keyframes up-down {
    from {
      transform: translatey(0px);
    }
    to {
      transform: translatey(-1.5px);
    }
  }
`;
